<template>
    <div
        class="modal fade"
        id="newStoryModal"
        tabindex="-1"
        aria-labelledby="newStoryModalLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content bg-dark text-light rounded-3 shadow-lg">
                <div class="modal-header">
                    <h5 class="modal-title" id="newStoryModalLabel">
                        New Story
                    </h5>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>

                <div class="modal-body">
                    <div class="mb-3 input-group">
                        <span class="input-group-text">Story Name</span>
                        <input
                            type="text"
                            class="form-control"
                            id="story-name"
                            v-model="storyName"
                            placeholder="Enter story name"
                        />
                    </div>

                    <div class="mb-3">
                        <label for="storyImageInput" class="form-label"
                            >Story Image</label
                        >
                        <input
                            class="form-control"
                            type="file"
                            id="storyImageInput"
                            @change="addStoryImage"
                            accept="image/*"
                        />
                    </div>

                    <div class="text-center" v-if="newStory.image">
                        <img
                            :src="newStory.image"
                            alt="Story Image Preview"
                            class="img-fluid rounded shadow-sm"
                            style="max-height: 300px"
                        />
                    </div>
                </div>

                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        class="btn btn-primary"
                        @click="createStory"
                    >
                        Create
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useRosterStore } from "@/stores/index";

export default {
    name: "NewStoryModal",
    data() {
        return {
            storyName: "",
            newStory: { name: "", encounters: [], doomclock: 0, image: null },
        };
    },
    methods: {
        addStoryImage(event) {
            const file = event.target.files[0];
            if (file && file.type.startsWith("image/")) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const img = new Image();
                    img.onload = () => {
                        const canvas = document.createElement("canvas");
                        const ctx = canvas.getContext("2d");
                        let width = img.width;
                        let height = img.height;

                        // Maintain aspect ratio, max 1000px
                        if (width > 1000 || height > 1000) {
                            if (width > height) {
                                height = Math.round((height *= 1000 / width));
                                width = 1000;
                            } else {
                                width = Math.round((width *= 1000 / height));
                                height = 1000;
                            }
                        }

                        canvas.width = width;
                        canvas.height = height;
                        ctx.drawImage(img, 0, 0, width, height);

                        const base64String = canvas.toDataURL(file.type);
                        this.newStory.image = base64String;
                    };
                    img.src = e.target.result;
                };
                reader.readAsDataURL(file);
            }
        },

        createStory() {
            const name = this.storyName.trim();

            if (name === "") {
                alert("Story name cannot be empty.");
                return;
            }

            const rosterStore = useRosterStore();

            if (rosterStore.stories.some((story) => story.name === name)) {
                alert("A story with this name already exists.");
                return;
            }

            this.newStory.name = name;
            rosterStore.addStory(this.newStory);

            // Reset fields
            this.storyName = "";
            this.newStory = {
                name: "",
                encounters: [],
                doomclock: 0,
                image: null,
            };

            // Close modal
            const modalEl = document.getElementById("newStoryModal");
            const modal =
                window.bootstrap.Modal.getInstance(modalEl) ||
                new window.bootstrap.Modal(modalEl);
            modal.hide();
        },
    },
};
</script>

<style scoped>
img {
    border-radius: 10px;
    max-height: 300px;
    object-fit: contain;
}
</style>
